import React from 'react';

const FilterCard = (props) => {

  return (
    <React.Fragment>

      {props.kpi2 !== '' ?
        <div className="card h-100 border">
          <div className="card-body text-center">
          <h6 className="card-subtitle pb-2 text-muted">{props.desc}</h6>
            <div>{props.kpi1}<br />
              <div>to</div>
              <div>{props.kpi2}</div>
            </div>
          </div>
        </div>
        :
        <div className="card h-100 border">
          <div className="card-body text-center">
            <h6 className="card-subtitle pb-2 text-muted">{props.desc}</h6>
            <div>{props.kpi1}</div>
          </div>
        </div>
      }

    </React.Fragment>
  )

}

export default FilterCard;
